<div style="display: flex; direction: columns; justify-content: space-evenly; gap: 1em; padding: 1em;">
    <mat-card class="content-card">
        <mat-card-header>
            <mat-card-title>
                Suspense
                <span *ngIf="zero_balance_list">
                    <app-custom-export-excel [sheetArray]="suspenseFileSheet"
                        [fileName]="suspenseFile"></app-custom-export-excel>
                </span>
            </mat-card-title>            
        </mat-card-header>
        <mat-card-content class="scrollable-card-content">
            <table mat-table [dataSource]="suspense_list" class="flat-table">
                <ng-container matColumnDef="loan_number">
                    <th mat-header-cell *matHeaderCellDef> Loan Number </th>
                    <td mat-cell *matCellDef="let element"> {{element.loan_number}} </td>
                </ng-container>
                <ng-container matColumnDef="suspense">
                    <th mat-header-cell *matHeaderCellDef> Suspense </th>
                    <td mat-cell *matCellDef="let element"> {{element.suspense | currency }} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="suspenseCols; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: suspenseCols;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
    <mat-card class="content-card">
        <mat-card-header>
            <mat-card-title>
                Zero balance
                <span *ngIf="zero_balance_list">
                    <app-custom-export-excel [sheetArray]="zeroFileSheet"
                        [fileName]="zeroFile"></app-custom-export-excel>
                </span>
            </mat-card-title>            
        </mat-card-header>
        <mat-card-content class="scrollable-card-content">
            <table mat-table [dataSource]="zero_balance_list" class="flat-table">
                <ng-container matColumnDef="loan_number">
                    <th mat-header-cell *matHeaderCellDef> Loan Number </th>
                    <td mat-cell *matCellDef="let element"> {{element.loan_number}} </td>
                </ng-container>
                <ng-container matColumnDef="payoff_date">
                    <th mat-header-cell *matHeaderCellDef> Payoff Date </th>
                    <td mat-cell *matCellDef="let element"> {{element.payoff_date}} </td>
                </ng-container>
                <ng-container matColumnDef="current_interest_rate">
                    <th mat-header-cell *matHeaderCellDef> Interest Rate </th>
                    <td mat-cell *matCellDef="let element"> {{element.current_interest_rate}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="zeroBalCols"></tr>
                <tr mat-row *matRowDef="let row; columns: zeroBalCols;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
    <mat-card class="content-card">
        <mat-card-header>
            <mat-card-title>
                Zero balance with interest
                <span *ngIf="zero_with_interest_list">
                    <app-custom-export-excel *ngIf="zero_with_interest_list" [sheetArray]="interestFileSheet"
                        [fileName]="interestFile"></app-custom-export-excel>
                </span>
            </mat-card-title>            
        </mat-card-header>
        <mat-card-content class="scrollable-card-content">
            <table mat-table [dataSource]="zero_with_interest_list" class="flat-table">
                <ng-container matColumnDef="loan_number">
                    <th mat-header-cell *matHeaderCellDef> Loan Number </th>
                    <td mat-cell *matCellDef="let element"> {{element.loan_number}} </td>
                </ng-container>
                <ng-container matColumnDef="current_interest_balance">
                    <th mat-header-cell *matHeaderCellDef> Current Interest Balance </th>
                    <td mat-cell *matCellDef="let element"> {{element.current_interest_balance | currency}} </td>
                </ng-container>
                <ng-container matColumnDef="days_past_due">
                    <th mat-header-cell *matHeaderCellDef> DPD </th>
                    <td mat-cell *matCellDef="let element"> {{element.days_past_due}} </td>
                </ng-container>
                <ng-container matColumnDef="current_interest_rate">
                    <th mat-header-cell *matHeaderCellDef> Interest Rate </th>
                    <td mat-cell *matCellDef="let element"> {{element.current_interest_rate}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="zeroInterestCols"></tr>
                <tr mat-row *matRowDef="let row; columns: zeroInterestCols;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>